import { useEffect, useState } from "react";
import { Container, Row, Col, Form, Spinner } from "react-bootstrap";
import { useForm, SubmitHandler } from "react-hook-form";
import { CreateCPIndAppType, CreateIndAppType } from "./types/CreateIndAppType";
import Input from "../../../../../components/common/Input";
import CountryDropdown from "../../../../../components/common/CountryDropdown";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../redux/store";
import { createAppAction } from "../redux/action/createAppAction";
import SectionHeading from "../../../../../components/common/SectionHeading";
import Button from "../../../../../components/common/Button";
import { useNavigate } from "react-router-dom";
import TaxDetailsIndia from "../components/TaxDetailsIndia";
import TaxDetailsForeign from "../components/TaxDeatilsForeign";
import { DisplayBox } from "../../../../../components/containers/DisplayBox";
import { parseAddress } from "../../../../../utils/functions/parseAddress";
import { createAddressAction } from "../redux/action/createAddressAction";

import { getCinFromPanAction } from "../redux/action/getCinFromPanAction";
import ParticipantType from "../../../../../components/common/ParticipantType";
import IsdCode from "../../../../../components/common/dropdowns/IsdCode";
import { updateAppAction } from "../redux/action/updateAppAction";
import { getAddressFromCinAction } from "../redux/action/getAddressFromCinAction";
import { convertDateFormat } from "../../../../../utils/functions/convertDateFormat";
import NavbarVTX from "../../../../../components/common/Navbar";
import {
  ALPHABETS_REGEX,
  EMAIL_REGEX,
  PHONE_REGEX,
} from "../../../../constants/regexPatterns";
import ReferredByDropdown from "../../../../../components/common/dropdowns/CPReferredBy";
import RadioButton from "../../../../../components/common/RadioButton";
import PhoneInputWithDropdown from "../../../../../components/common/PhoneInput";
import RmNameType from "../../../../../components/common/dropdowns/RmName";
import DatePicker from "../../../../../components/common/DatePicker";
import RMDeclarationText from "../components/RMDeclaration";
import CheckBoxes from "../../../../../components/common/CheckBoxes";
import { getAppAction } from "../redux/action/getAppAction";
import CurrentDatePicker from "../../../../../components/common/CurrentDatePicker";
import { getCurrentDate } from "../../../../../utils/functions/getCurrentDate";
import {
  getSessionId,
  getUsername,
  getUserRole,
  getUserUid,
} from "../../../../../utils/tokenHandlers";
import { getRmName } from "../../../../apis/listOfValues/getRmName";
import { getBusinessDetailsFromCINAction } from "../redux/action/getBusinessDetailsFromCINAction";
import { logoutConCurrLoginAction } from "../../../../auth/redux/action/logoutConCurrLoginAction";
import { getBankAccountType } from "../../../../apis/listOfValues/getBankAccountType";

const OpsCPCreateAppPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<CreateCPIndAppType>({
    shouldUnregister: true,
  });

  const gstinValue = watch("business_gst");
  const selectedRmId = watch("employee_name");
  const [rmData, setRmData] = useState([]);
  const country = watch("business_registration_country_id");
  const isCountryIndia =
    Number(watch("business_registration_country_id")) ===
    Number(process.env.REACT_APP_COUNTRY_ID);
  const isCountryNotIndia =
    Number(watch("business_registration_country_id")) !==
    Number(process.env.REACT_APP_COUNTRY_ID);

  const constitutionType = watch("business_constitution_type");
  const particiapantRole = watch("business_participant_type");
  const phoneIsd = watch("customer_contact_mobile_country_code");
  const phoneNo = watch("customer_contact_mobile");

  const referredBy = Number(watch("referred_by"));

  const [showError, setShowError] = useState<string>("");
  const [spinner, setSpinner] = useState<boolean>(false);
  const userRole = getUserRole();
  const [logoutSpinner, setLogoutSpinner] = useState(false);
  const userName = getUsername();
  const onSubmit: SubmitHandler<CreateCPIndAppType> = async (formData) => {
    if (phoneIsd === "+91" && phoneNo.toString().length !== 10) {
      alert("Please enter 10 digit number");
    } else {
      setSpinner(true);
      const data = {
        ...formData,
        employee_declaration_accepted: "True",
        is_counterparty: true,
        stage: "New / Draft",
        business_registration_country_id: Number(
          formData.business_registration_country_id,
        ),
        referred_by: Number(formData.referred_by),
        employee_name: Number(formData.employee_name),
        constitution_type_flag: true,
      };
      // console.log(data);
      if (Number(country) === Number(process.env.REACT_APP_COUNTRY_ID)) {
        data.business_pan = gstinValue.substring(2, 12);
        data.business_tanno_issuing_authority = "Income Tax Department";
      } else if (Number(country) !== Number(process.env.REACT_APP_COUNTRY_ID)) {
        data.is_foreign = true;
        data.business_tax_jurisdiction_country_id = Number(
          formData.business_registration_country_id,
        );
        data.business_incorporation_country_id = Number(
          formData.business_registration_country_id,
        );
      }

      // console.log(data);
      dispatch(createAppAction(data)).then((response) => {
        let appId = response.payload.result;
        if (response.payload.error) {
          setShowError(response.payload.error.data.message);
          setSpinner(false);
          return;
        }
        if (isCountryIndia) {
          if (particiapantRole == "Financier") {
            dispatch(
              getCinFromPanAction({
                pan: gstinValue.substring(2, 12),
                customerId: response.payload.result,
              }),
            ).then((response) => {
              if (response.payload.result) {
                // // console.log(
                //   "PLACE of REG",
                //   response.payload.result[0].ROC_Code,
                //   response.payload.result[0].Date_of_Incorporation
                // );
                dispatch(
                  updateAppAction({
                    customerId: appId,
                    updateCustomerData: {
                      is_cin_captured: true,
                      business_cin_no:
                        response.payload.result.result[0].entityId,
                      api_cin_flag: true,
                    },
                  }),
                ).then(() => {
                  const cinValue = response.payload.result.result[0].entityId;
                  dispatch(getBusinessDetailsFromCINAction(cinValue)).then(
                    (businessDetailsFields) => {
                      // console.log(businessDetailsFields.payload);
                      let fetchedFields =
                        businessDetailsFields.payload?.result
                          ?.statutoryRegistration;
                      const IEC_number = fetchedFields?.iec[0]?.iec;
                      const LEI_number = fetchedFields?.lei[0]?.lei;
                      // console.log(
                      //   fetchedFields?.exchangeInformation?.bseSecurity[0]?.srcWebsites[0]
                      // );
                      const companyWebsite =
                        fetchedFields?.exchangeInformation?.bseSecurity[0]
                          ?.srcWebsites[0];
                      const natureofActivity =
                        fetchedFields?.mca[0]?.activityGroup_;

                      dispatch(
                        updateAppAction({
                          customerId: appId,
                          updateCustomerData: {
                            business_iecno: IEC_number ? IEC_number : "",
                            business_legal_entity_identifier: LEI_number
                              ? LEI_number
                              : "",
                            business_website: companyWebsite
                              ? companyWebsite
                              : "",
                            business_nature_activity: natureofActivity
                              ? natureofActivity
                              : "",

                            api_lei_flag: LEI_number ? true : false,
                            api_nature_activity_flag: natureofActivity
                              ? true
                              : false,
                            api_iecno_flag: IEC_number ? true : false,
                            api_website_flag: companyWebsite ? true : false,
                          },
                        }),
                      );
                      // console.log(
                      //   businessDetailsFields.payload?.result?.statutoryRegistration,
                      //   "here"
                      // );
                      // console.log(fetchedFields?.iec[0]?.iec, "IEC");
                      // console.log(fetchedFields?.lei[0]?.lei, "LEI");
                      // console.log(fetchedFields?.tan[0]?.tan, "tan");
                      // return;
                    },
                  );
                });

                dispatch(
                  getAddressFromCinAction({
                    cin: response.payload.result.result[0].entityId,
                    customerId: appId,
                  }),
                ).then((addressResponse) => {
                  try {
                    if (addressResponse.payload) {
                      // navigate(`/india/financier/business-details/${appId}`);
                      // return;
                      let address =
                        addressResponse.payload.result.result
                          .Registered_Address;
                      let parseAddressDetails = parseAddress(address);
                      let addressDetailsData = {
                        customer_id: appId,
                        type: "Registered",
                        ...parseAddressDetails,
                        api_line_1_flag: true,
                        api_line_2_flag: true,
                        postal_pincode_api_success: true,
                        api_city_flag: true,
                        api_district_flag: true,
                        api_state_flag: true,
                        api_country_flag: true,
                      };
                      dispatch(createAddressAction(addressDetailsData)).then(
                        (res) => {
                          dispatch(
                            updateAppAction({
                              customerId: appId,
                              updateCustomerData: {
                                business_registration_place:
                                  addressResponse.payload.result.result
                                    .ROC_Code,
                                business_registration_date: convertDateFormat(
                                  addressResponse.payload.result.result
                                    .Date_of_Incorporation,
                                ),
                                api_business_registration_date_flag:
                                  addressResponse.payload.result.result
                                    .Date_of_Incorporation
                                    ? true
                                    : false,
                                api_business_registration_place_flag:
                                  addressResponse.payload.result.result.ROC_Code
                                    ? true
                                    : false,
                              },
                            }),
                          ).then(() => {
                            if (appId) {
                              navigate(
                                `/india/financier/business-details/${appId}`,
                              );
                            } else {
                              alert("Something went wrong!");
                            }
                          });
                        },
                      );
                    }
                  } catch (err) {
                    navigate(`/india/financier/business-details/${appId}`);
                  }
                });
              } else {
                if (appId) {
                  navigate(`/india/financier/business-details/${appId}`);
                } else {
                  alert("Something went wrong!");
                }
              }
            });
          } else {
            if (
              constitutionType == "LLC" ||
              constitutionType == "LLP" ||
              constitutionType == "PLC"
            ) {
              dispatch(
                getCinFromPanAction({
                  pan: gstinValue.substring(2, 12),
                  customerId: response.payload.result,
                }),
              ).then((response) => {
                if (response.payload.result) {
                  // // console.log(
                  //   "PLACE of REG",
                  //   response.payload.result[0].ROC_Code,
                  //   response.payload.result[0].Date_of_Incorporation
                  // );
                  dispatch(
                    updateAppAction({
                      customerId: appId,
                      updateCustomerData: {
                        is_cin_captured: true,
                        business_cin_no:
                          response.payload.result.result[0].entityId,
                        api_cin_flag: true,
                      },
                    }),
                  ).then(() => {
                    const cinValue = response.payload.result.result[0].entityId;
                    dispatch(getBusinessDetailsFromCINAction(cinValue)).then(
                      (businessDetailsFields) => {
                        // console.log(businessDetailsFields.payload);
                        let fetchedFields =
                          businessDetailsFields.payload?.result
                            ?.statutoryRegistration;
                        const IEC_number = fetchedFields?.iec[0]?.iec;
                        const LEI_number = fetchedFields?.lei[0]?.lei;
                        // console.log(
                        //   fetchedFields?.exchangeInformation?.bseSecurity[0]?.srcWebsites[0]
                        // );
                        const companyWebsite =
                          fetchedFields?.exchangeInformation?.bseSecurity[0]
                            ?.srcWebsites[0];
                        const natureofActivity =
                          fetchedFields?.mca[0]?.activityGroup_;
                        dispatch(
                          updateAppAction({
                            customerId: appId,
                            updateCustomerData: {
                              business_iecno: IEC_number ? IEC_number : "",
                              business_legal_entity_identifier: LEI_number
                                ? LEI_number
                                : "",
                              business_website: companyWebsite
                                ? companyWebsite
                                : "",
                              business_nature_activity: natureofActivity
                                ? natureofActivity
                                : "",
                              api_lei_flag: LEI_number ? true : false,
                              api_nature_activity_flag: natureofActivity
                                ? true
                                : false,
                              api_iecno_flag: IEC_number ? true : false,
                              api_website_flag: companyWebsite ? true : false,
                            },
                          }),
                        );
                        // console.log(
                        //   businessDetailsFields.payload?.result?.statutoryRegistration,
                        //   "here"
                        // );
                        // console.log(fetchedFields?.iec[0]?.iec, "IEC");
                        // console.log(fetchedFields?.lei[0]?.lei, "LEI");
                        // console.log(fetchedFields?.tan[0]?.tan, "tan");
                        // return;
                      },
                    );
                  });

                  dispatch(
                    getAddressFromCinAction({
                      cin: response.payload.result.result[0].entityId,
                      customerId: appId,
                    }),
                  ).then((addressResponse) => {
                    try {
                      if (addressResponse.payload) {
                        // navigate(`/india/corporate/business-details/${appId}`);
                        // return;
                        let address =
                          addressResponse.payload.result.result
                            .Registered_Address;
                        let parseAddressDetails = parseAddress(address);
                        let addressDetailsData = {
                          customer_id: appId,
                          type: "Registered",
                          ...parseAddressDetails,
                          api_line_1_flag: true,
                          api_line_2_flag: true,
                          postal_pincode_api_success: true,
                          api_city_flag: true,
                          api_district_flag: true,
                          api_state_flag: true,
                          api_country_flag: true,
                        };
                        dispatch(createAddressAction(addressDetailsData)).then(
                          (res) => {
                            dispatch(
                              updateAppAction({
                                customerId: appId,
                                updateCustomerData: {
                                  business_registration_place:
                                    addressResponse.payload.result.result
                                      .ROC_Code,
                                  business_registration_date: convertDateFormat(
                                    addressResponse.payload.result.result
                                      .Date_of_Incorporation,
                                  ),
                                  api_business_registration_date_flag:
                                    addressResponse.payload.result.result
                                      .Date_of_Incorporation
                                      ? true
                                      : false,
                                  api_business_registration_place_flag:
                                    addressResponse.payload.result.result
                                      .ROC_Code
                                      ? true
                                      : false,
                                },
                              }),
                            ).then(() => {
                              if (appId) {
                                navigate(
                                  `/india/corporate/business-details/${appId}`,
                                );
                              } else {
                                alert("Something went wrong!");
                              }
                            });
                          },
                        );
                      }
                    } catch (err) {
                      navigate(`/india/corporate/business-details/${appId}`);
                    }
                  });
                } else {
                  if (appId) {
                    navigate(`/india/corporate/business-details/${appId}`);
                  } else {
                    alert("Something went wrong!");
                  }
                }
              });
            } else {
              if (appId) {
                // console.log(gstinValue);
                dispatch(getBusinessDetailsFromCINAction(gstinValue)).then(
                  (businessDetailsFields) => {
                    console.log(businessDetailsFields.payload);
                    let fetchedFields =
                      businessDetailsFields.payload?.result
                        ?.statutoryRegistration;
                    const IEC_number = fetchedFields?.iec[0]?.iec;
                    const LEI_number = fetchedFields?.lei[0]?.lei;
                    // console.log(
                    //   fetchedFields?.exchangeInformation?.bseSecurity[0]?.srcWebsites[0]
                    // );
                    const companyWebsite =
                      fetchedFields?.exchangeInformation?.bseSecurity[0]
                        ?.srcWebsites[0];
                    const natureofActivity =
                      fetchedFields?.mca[0]?.activityGroup_;
                    const dateOfIncorporation =
                      fetchedFields?.mca[0]?.dateOfIncorporation;
                    const placeOfIncorporation =
                      fetchedFields?.lei[0]?.headquartersAddress?.city;

                    dispatch(
                      updateAppAction({
                        customerId: appId,
                        updateCustomerData: {
                          business_iecno: IEC_number ? IEC_number : "",
                          business_legal_entity_identifier: LEI_number
                            ? LEI_number
                            : "",
                          business_website: companyWebsite
                            ? companyWebsite
                            : "",
                          business_nature_activity: natureofActivity
                            ? natureofActivity
                            : "",
                          business_registration_place: placeOfIncorporation
                            ? placeOfIncorporation
                            : "",
                          business_registration_date:
                            convertDateFormat(dateOfIncorporation),

                          api_lei_flag: LEI_number ? true : false,
                          api_nature_activity_flag: natureofActivity
                            ? true
                            : false,
                          api_iecno_flag: IEC_number ? true : false,
                          api_website_flag: companyWebsite ? true : false,
                          api_business_registration_date_flag:
                            dateOfIncorporation ? true : false,
                          api_business_registration_place_flag:
                            placeOfIncorporation ? true : false,
                        },
                      }),
                    ).then(() => {
                      let address = fetchedFields?.mca[0]?.registeredAddress;
                      let parseAddressDetails = parseAddress(address);
                      let addressDetailsData = {
                        customer_id: appId,
                        type: "Registered",
                        ...parseAddressDetails,
                        api_line_1_flag: true,
                        api_line_2_flag: true,
                        postal_pincode_api_success: true,
                        api_city_flag: true,
                        api_district_flag: true,
                        api_state_flag: true,
                        api_country_flag: true,
                      };
                      dispatch(createAddressAction(addressDetailsData)).then(
                        () => {
                          navigate(
                            `/india/non-corporate/business-details/${appId}`,
                          );
                        },
                      );
                    });

                    // console.log(
                    //   businessDetailsFields.payload?.result?.statutoryRegistration,
                    //   "here"
                    // );
                    // console.log(fetchedFields?.iec[0]?.iec, "IEC");
                    // console.log(fetchedFields?.lei[0]?.lei, "LEI");
                    // console.log(fetchedFields?.tan[0]?.tan, "tan");
                    // return;
                  },
                );
              } else {
                alert("Something went wrong!");
              }
            }
          }
        } else {
          if (particiapantRole == "Financier") {
            if (appId) {
              navigate(`/foreign/financier/business-details/${appId}`);
            } else {
              alert("Something went wrong!");
            }
          } else {
            if (appId) {
              navigate(`/foreign/business-details/${appId}`);
            } else {
              alert("Something went wrong!");
            }
          }
        }
      });
    }
  };

  const participationRoleOptions = [
    { label: "Seller", value: "Seller" },
    { label: "Buyer", value: "Buyer" },
  ];

  useEffect(() => {
    // Set default value for submitted_date using react-hook-form setValue
    setValue("submitted_date", getCurrentDate());
  }, [setValue]);

  useEffect(() => {
    getRmName(getSessionId()).then((response) => {
      setRmData(response.result.result);
    });
  }, []);

  useEffect(() => {
    const sessionId = getSessionId();
    if (!sessionId) {
      navigate("/");
      return;
    }
    if (userRole == "checker") {
      alert("Error: Unauthorised Access");
      navigate("/");
      return;
    }

    try {
      getBankAccountType(sessionId).then((resp) => {
        // console.log(resp);
        if (resp?.error) {
          alert(resp.error?.data?.message);
          handleLogout();
        } else if (resp?.result?.count < 1) {
          handleLogout();
        }
      });
    } catch (error) {
      alert(error);
    }
  }, []);

  useEffect(() => {
    if (selectedRmId && rmData.length > 0) {
      const rmDetails: any = rmData.filter((rm: any) => rm.id == selectedRmId);
      // console.log("RM DETAILS", rmDetails);
      setValue("employee_id", rmDetails[0].barcode);
    }
  }, [selectedRmId]);

  useEffect(() => {
    if (referredBy) {
      // console.log(referredBy);
      dispatch(getAppAction(referredBy)).then((response) => {
        // console.log(
        //   "ref resp",
        //   response.payload.result.business_participant_type
        // );
        try {
          const referredBy_Role =
            response.payload.result.business_participant_type;
          if (referredBy_Role === "Seller") {
            setValue("business_participant_type", "Buyer");
          } else if (referredBy_Role === "Buyer") {
            setValue("business_participant_type", "Seller");
          } else {
            alert("Something went wrong, Please contact admin!");
          }
        } catch (err) {
          // console.log("Could not get the role of referred by");
        }
      });
    }
  }, [referredBy]);

  const handleLogout = () => {
    // Add your logout logic here
    setLogoutSpinner(true);
    // console.log("Hello, logout clicked!");
    const userId = getUserUid();
    dispatch(logoutConCurrLoginAction(userId)).then((resp: any) => {
      // console.log("Logout resp--", resp);
      if (userRole === "guest") {
        localStorage.clear();
        navigate("/");
      } else if (userRole === "maker" || userRole === "checker") {
        localStorage.clear();
        navigate("/ops/login");
      } else {
        <></>;
      }
      setLogoutSpinner(false);
    });

    // // console.log("LogOut resp--", logOut);
  };

  return (
    <>
      <Container>
        <Row>
          <Col className="m-2">
            <NavbarVTX></NavbarVTX>
          </Col>
          <Col
            md={11}
            className="text-end"
            style={{ marginTop: "-5%", color: "#214382" }}
          >
            {userName} as {userRole}
            <span
              style={{ color: "#214382", marginLeft: "2%", cursor: "pointer" }}
              onClick={handleLogout}
            >
              {logoutSpinner ? (
                <Spinner animation="border" variant="primary" size="sm" />
              ) : (
                <>LogOut</>
              )}
            </span>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={6}>
            <SectionHeading text="CONTACT PERSON DETAILS" />
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Input
                label="Contact Person Name"
                name="customer_contact_name"
                register={register}
                required
                regexPattern={ALPHABETS_REGEX}
                requiredMessage="Name is required"
                error={errors.customer_contact_name?.message}
                placeholder="Enter Name"
              />
              <PhoneInputWithDropdown
                label={"Cellphone"}
                name={"customer_contact_mobile"}
                register={register}
                required
                isdCodeName={"customer_contact_mobile_country_code"}
                isdCodeRegister={register}
                // disabled
                // inputDefaultValue={`${localStorage.getItem("guestMobile")}`}
                // dropdownDefaultValue={"+91"}
                // defaultValue={`${localStorage.getItem(
                //   "customer_contact_mobile"
                // )}`}
                error={errors.customer_contact_mobile?.message}
                regexPattern={PHONE_REGEX}
                placeholder="Enter Mobile"
              />
              <Input
                label="Contact Person Email"
                type="email"
                name="customer_contact_email"
                register={register}
                required
                requiredMessage="Email is required"
                regexPattern={EMAIL_REGEX}
                regexMessage="Invalid Email Format"
                error={errors.customer_contact_email?.message}
                placeholder="Enter Email"
              />
              <Input
                label="Designation"
                type="designation"
                name="designation"
                register={register}
                // required
                // placeholder="Enter your Designation"
                requiredMessage="Designation is required"
                error={errors.designation?.message}
                placeholder="Enter Designation"
                regexPattern={ALPHABETS_REGEX}
              />
              <SectionHeading text="BUSINESS DETAILS" />
              <ReferredByDropdown
                name="referred_by"
                label={"Referred by Participant"}
                register={register}
                required
                requiredMessage="Referred by is required"
                error={errors.referred_by?.message}
              />

              <RadioButton
                label="Participation Role"
                name="business_participant_type"
                options={participationRoleOptions}
                register={register}
                // required
                disabled
                // requiredMessage="Participation role is required"
                // error={errors.business_participant_type?.message}
              />

              <CountryDropdown
                label="Business Registration Country"
                name="business_registration_country_id"
                register={register}
                required
                requiredMessage="Please select country"
                error={errors.business_registration_country_id?.message}
              />
              <DisplayBox display={isCountryIndia}>
                <TaxDetailsIndia
                  register={register}
                  errors={errors}
                  watch={watch}
                  setValue={setValue}
                />
              </DisplayBox>
              <DisplayBox display={isCountryNotIndia}>
                <TaxDetailsForeign
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </DisplayBox>
              <SectionHeading text="RM DETAILS" />
              <RmNameType
                label="Rm Name"
                name="employee_name"
                register={register}
                required
                requiredMessage="RM name is required"
                error={errors.employee_name?.message}
                // disabled
              />
              <Input
                label="Employee ID"
                name="employee_id"
                register={register}
                required
                requiredMessage="Employee ID is required"
                error={errors.employee_id?.message}
                placeholder="Enter Employee ID"
                disabled
              />
              {/* <DatePicker
                label="RM Sign Date"
                name="submitted_date"
                register={register}
                required
                requiredMessage="Date is required"
                error={errors.submitted_date?.message}
              /> */}
              <CurrentDatePicker
                name={"submitted_date"}
                label={"RM Sign Date"}
                register={register}
                // required
                isCurrentDate
                // requiredMessage="Date is required"
                disabled
                // error={errors.submitted_date?.message}
              />
              <RMDeclarationText />
              <CheckBoxes
                label={"I Accept the above"}
                name={"employee_declaration_accepted"}
                register={register}
                required
                requiredMessage="Please accept the Declaration"
                error={errors.employee_declaration_accepted?.message}
              />
              {/* <SectionHeading text="OTHER DETAILS" /> */}
              {/* <Input
                label="RM Name"
                type="text"
                name="employee_name"
                register={register}
                required
                requiredMessage="RM Name is required"
                error={errors.employee_name?.message}
              />
              <DatePicker
                label="RM Sign Date"
                name="submitted_date"
                register={register}
                required
                requiredMessage="Date is required"
                error={errors.submitted_date?.message}
              /> */}
              {/* <RadioButton
                label="FTR/ FTNR"
                name="business_is_ftr_ftnr"
                options={ftnrOptions}
                register={register}
                required
                //defaultValue="buyer"
                error={errors.business_is_ftr_ftnr?.message}
              /> */}
              {/* <DisplayBox display={ftnrRadioSelectedValue}>
                <Input
                  label="FTNR Remark"
                  name="business_ftnr_remarks"
                  register={register}
                  error={errors.business_is_ftr_ftnr?.message}
                />
              </DisplayBox> */}
              {showError && <p style={{ color: "red" }}>{showError}</p>}
              <Row>
                <Col md={12} className="mt-3 text-end">
                  {/* <Button
                    label="Reset"
                    type="reset"
                    variant="outline-primary"
                  /> */}
                  {spinner ? (
                    <Spinner variant="primary" animation="border"></Spinner>
                  ) : (
                    <Button label="Create" type="submit" />
                  )}
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default OpsCPCreateAppPage;
